// Ícone de cada aba: o emoji, ou um desenho próprio quando não existe emoji bom (Scanner e PDF Edit, 0.51).
import { Text, View } from 'react-native';
import Svg, { Circle, G, Path, Rect, Text as SvgText } from 'react-native-svg';

/** Scanner de mesa com a folha entrando e a luz verde de leitura. */
export const IconeScanner = ({ tam = 20 }: { tam?: number }) => (
  <Svg width={tam} height={tam} viewBox="0 0 24 24">
    <Rect x={6} y={1.5} width={12} height={12} rx={1.2} fill="#FFFFFF" stroke="#CBD5E1" strokeWidth={0.6} />
    <Path d="M8.3 4.5h7.4M8.3 6.8h7.4M8.3 9.1h4.8" stroke="#94A3B8" strokeWidth={1} strokeLinecap="round" />
    <Rect x={1.5} y={11.5} width={21} height={9.5} rx={2.4} fill="#475569" />
    <Rect x={1.5} y={11.5} width={21} height={3.2} rx={1.6} fill="#64748B" />
    <Rect x={3.2} y={12.4} width={17.6} height={1.4} rx={0.7} fill="#22D3EE" />
    <Rect x={3} y={12} width={18} height={2.2} rx={1.1} fill="#67E8F9" opacity={0.35} />
    <Rect x={4} y={17.2} width={5} height={1.6} rx={0.8} fill="#CBD5E1" />
    <Circle cx={19} cy={18} r={1.1} fill="#34D399" />
  </Svg>
);

/** Folha de PDF com a faixa vermelha e um lápis. */
export const IconePdfEdit = ({ tam = 20 }: { tam?: number }) => (
  <Svg width={tam} height={tam} viewBox="0 0 24 24">
    <Path d="M5.5 1.5h8.6l5.4 5.4v13.6a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2V3.5a2 2 0 0 1 2-2z" fill="#FFFFFF" stroke="#E2E8F0" strokeWidth={0.6} />
    <Path d="M14.1 1.5v4.4a1 1 0 0 0 1 1h4.4z" fill="#FCA5A5" />
    <Rect x={1.5} y={9.6} width={13.4} height={6.4} rx={1.6} fill="#DC2626" />
    <SvgText x={8.2} y={14.5} fontSize={4.9} fontWeight="bold" fill="#FFFFFF" textAnchor="middle">PDF</SvgText>
    <G transform="rotate(45 18.5 17)">
      <Rect x={16.9} y={10.2} width={3.2} height={10.6} rx={0.6} fill="#F59E0B" />
      <Rect x={16.9} y={10.2} width={3.2} height={2} rx={0.6} fill="#FB7185" />
      <Path d="M16.9 20.8h3.2l-1.6 2.6z" fill="#FDE68A" />
      <Path d="M18 22.6h1l-0.5 0.8z" fill="#1F2937" />
    </G>
  </Svg>
);

/** O ícone da aba: desenho próprio (scanner e PDF Edit) ou o emoji.
 *  Sempre dentro de uma caixa do mesmo tamanho, centralizada, para que desenhos e emojis
 *  fiquem na mesma linha e os nomes embaixo fiquem alinhados (0.52). */
export function IconeAba({ id, icon, tam = 20, opacity = 1 }: { id?: string; icon: string; tam?: number; opacity?: number }) {
  const alto = Math.round(tam * 1.35);
  const caixa = { height: alto, minWidth: alto, alignItems: 'center' as const, justifyContent: 'center' as const, opacity };
  if (id === 'scanner') return <View style={caixa}><IconeScanner tam={Math.round(tam * 1.1)} /></View>;
  if (id === 'pdfedit') return <View style={caixa}><IconePdfEdit tam={Math.round(tam * 1.1)} /></View>;
  return (
    <View style={caixa}>
      <Text allowFontScaling={false} style={{ fontSize: tam, lineHeight: alto, textAlign: 'center', includeFontPadding: false, textAlignVertical: 'center' }}>{icon}</Text>
    </View>
  );
}
